import {
  CatalogItem,
  CatalogItemExtended,
  ItemType
} from '../models/catalog/catalog-item.model';

export interface CatalogState {
  data?: CatalogItem[];
  loading?: boolean;
  allItems?: CatalogItemExtended[];

  loadingGetItems?: boolean;
  errorGetItems?: string;

  loadingDeleteItem?: boolean;
  errorDeleteItem?: string;
  lastDeletedItem?: CatalogItem;

  loadingCreateItem?: boolean;
  errorCreateItem?: string;

  loadingUpdateItem?: boolean;
  errorUpdateItem?: string;
  lastUpdatedItem?: CatalogItem;

  inventoryItems?: CatalogItem[];
  loadingInventoryItems?: boolean;
  errorInventoryItems?: string;

  loadingCreateInventoryItem?: boolean;
  errorCreateInventoryItem?: string;
  //TODO: refactor the mess above so it looks like this
  crm?: crmStoreData;

  creatorStoreUniverses?: AnswerStructure;
  creatorStoreAdventures?: AnswerStructure;

  playerStore?: playerStoreData;
  contributors?: AnswerStructure;

  inventoryItem?: inventoryItemData;

  recycledDraftItems?: recycledDraftItemsData;
  recycledInventoryItems?: recycledInventoryItemsData;

}

/**
 * @interface AnswerStructure gives to each reference item the  list of items that are in its answer.
 * the respective data comes from the
 * @interface CatalogItem
 */
interface AnswerStructure {
  data?: CatalogItem[] | [];
  loading: boolean;
  error?: string;
}

/**
 * @interface itemStoreData extends the  AnswerStructure interface to add personalized  information about an item store
 * for the moment there is a boolean property
 * @property loading
 */
export interface itemStoreData extends AnswerStructure {
  // personalized properties
  loading: boolean;
}

/**
 * @interface crmStoreData  contains all information about an item that has beed sent to be published
 * and can be approved, rejected or be awating
 */
export interface crmStoreData {
  data?: {
    Items: {
      Approved: crmItems;
      Rejected: crmItems;
      AwaitingModeration: crmItems;
    };
    ContinuationToken?: string;
  };
  loading?: boolean;
  error?: string;
}

export interface creatorStoreData extends AnswerStructure {
  // personalized properties
  loading: boolean;
}

export type playerStoreData = AnswerStructure;

export type inventoryItemData = AnswerStructure;

export type recycledDraftItemsData = AnswerStructure;

export type recycledInventoryItemsData = AnswerStructure;

/**
 * @interface crmItems gets the total of items  in each category from CRM and also calls the information for each item
 */
interface crmItems {
  Total: number;
  Items: CatalogItem[];
}

/**
 * initializes the status of the items in the crm, contributors and creatorStoreUniverses
 */
export const initialState: CatalogState = {
  data: [],
  allItems: [],
  inventoryItems: [],
  crm: {
    data: {
      Items: {
        AwaitingModeration: {
          Items: [],
          Total: 0,
        },
        Approved: {
          Items: [],
          Total: 0,
        },
        Rejected: {
          Items: [],
          Total: 0,
        },
      },
    },
    loading: false,
  },
  contributors: {
    data: [],
    loading: false,
  },
  creatorStoreUniverses: {
    data: [],
    loading: false,
  },
};

/**
 *
 * @param state
 * @param action
 * @returns the response depending on the action stablished
 */
export function catalogReducer(
  state = initialState,
  action: { type: string; payload?: any; error?: string },
): CatalogState {

  switch (action.type) {
    /**
     *  Get Items reducer
     */
    case '[Catalog] Loading Get Items':
      return { ...state, loadingGetItems: true };
    case '[Catalog] Loaded Get Draft Items':
      return { ...state, loadingGetItems: false };
    case '[Catalog] Success Get Draft Items': {
      const itemsPayload: CatalogItem[] = action.payload;
      const initialData = state.allItems || [];
      const newData: CatalogItemExtended[] = itemsPayload.map((item: CatalogItem) => {
        const primaryType: ItemType = 'draft';
        return {
          item: item,
          data: {
            type: primaryType,
            types: [primaryType],
          },
        };
      });

      const allItems = mergeCatalogItemsExtended(initialData, newData);

      return {
        ...state,
        allItems: allItems,
        loadingGetItems: false,
        errorGetItems: null,
      };
    }
    case '[Catalog] Error Get Draft Items':
      return { ...state, loadingGetItems: false, errorGetItems: action.error };

    case 'add-draft-item': {
      return { ...state, allItems: [...state.allItems, action.payload.item] };
    }

    /* Single Draft Item reducer */
    case '[Catalog] Loading Get Draft Item':
      return { ...state };
    case '[Catalog] Loaded Get Draft Item':
      return { ...state };
    case '[Catalog] Success Get Draft Item': {
      const newItem: CatalogItem = action.payload;
      const newItemExtended: CatalogItemExtended = {
        data: { type: 'draft' },
        item: newItem,
      };
      const allItemsMinusNewOne = state.allItems.filter(
        (item) => item.item.Id !== newItem.Id,
      );

      const draftItems = state.data;
      const draftItemsMinusNewOne = draftItems.filter(
        (item) => item.Id !== newItem.Id,
      );

      return {
        ...state,
        data: [...draftItemsMinusNewOne, newItem],
        allItems: [...allItemsMinusNewOne, newItemExtended],
      };
    }
    case '[Catalog] Error Get Draft Item':
      return { ...state };

    /**
     *  Archived Draft items reducer
     */
    case '[Catalog] Loading Get Recycled Draft Items':
      return {
        ...state,
        recycledDraftItems: { ...state.recycledDraftItems, loading: true },
      };
    case '[Catalog] Loaded Get Recycled Draft Items':
      return {
        ...state,
        recycledDraftItems: { ...state.recycledDraftItems, loading: false },
      };
    case '[Catalog] Success Get Recycled Draft Items':
      return {
        ...state,
        recycledDraftItems: {
          ...state.recycledDraftItems,
          data: action.payload,
          loading: true,
        },
      };
    case '[Catalog] Error Get Recycled Draft Items':
      return {
        ...state,
        recycledDraftItems: {
          ...state.recycledDraftItems,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Delete Item reducer
     */
    case '[Catalog] Loading Delete Item': {
      const itemToDelete = state.data.filter(
        (item) => item.Id === action.payload.id,
      )[0];
      return {
        ...state,
        loadingDeleteItem: true,
        data: state.data.filter((item) => item.Id !== action.payload.id),
        lastDeletedItem: itemToDelete,
      };
    }
    case '[Catalog] Loaded Delete Item':
      return { ...state, loadingDeleteItem: false };
    case '[Catalog] Success Delete Item':
      return {
        ...state,
        data: state.data.filter((item) => item.Id !== action.payload.id),
        allItems: state.allItems.filter(
          (item) => item.item.Id !== action.payload.id,
        ),
      };
    case '[Catalog] Error Delete Item':
      if (state.lastDeletedItem) {
        return {
          ...state,
          errorDeleteItem: action.error,
          data: [...state.data, state.lastDeletedItem],
        };
      } else {
        return { ...state, errorDeleteItem: action.error };
      }

    /**
     *  Create Item reducer
     */
    case '[Catalog] Loading Create Item': {
      //Add data before the server answers
      const dummyData = { ...action.payload.item };
      dummyData.Id = '';
      dummyData.DisplayProperties = {};

      /*NEW STUFF*/
      const dummyDataExtended: CatalogItemExtended = {
        item: dummyData,
        data: { type: 'draft' },
      };
      /*NEW STUFF*/

      return {
        ...state,
        loadingCreateItem: true,
        data: [...state.data, dummyData],
        allItems: [...state.allItems, dummyDataExtended],
      };
    }
    case '[Catalog] Loaded Create Item':
      return { ...state, loadingCreateItem: false };
    case '[Catalog] Success Create Item': {
      //Replace the data with real data from the server
      const realData = action.payload.item;
      const stateWithoutDummyData = state.data.filter((item) => item.Id !== '');

      /*NEW STUFF*/
      const allItemsStateWithoutDummyData = state.allItems.filter(
        (item) => item.item.Id !== '',
      );

      const realDataExtended: CatalogItemExtended = {
        item: realData,
        data: { type: 'draft', types: ['draft'] },
      };
      /*NEW STUFF*/

      return {
        ...state,
        data: [...stateWithoutDummyData, realData],
        allItems: [...allItemsStateWithoutDummyData, realDataExtended],
      };
    }
    case '[Catalog] Error Create Item': {
      const stateWithoutDummyDataError = state.data.filter(
        (item) => item.Id !== '',
      );

      const allItemsStateWithoutDummyDataError = state.allItems.filter(
        (item) => item.item.Id !== '',
      );

      return {
        ...state,
        errorCreateItem: action.error,
        data: [...stateWithoutDummyDataError],
        allItems: [...allItemsStateWithoutDummyDataError],
      };
    }
    case '[Catalog] Loading Update Item': {
      const newItem = action.payload.item;
      return { ...state, lastUpdatedItem: newItem };
    }
    case '[Catalog] Loaded Update Item':
      return { ...state };
    case '[Catalog] Success Update Item': {
      const dataWithoutNewItemSuccess = state.data.filter(
        (item) => item?.Id !== action.payload?.item?.Id,
      );

      const newItemSuccess = action.payload.item;

      // if (state.data.length === 0)
      //   return { ...state, lastUpdatedItem: newItemSuccess };

      /*NEW STUFF*/
      const allItemsWithoutNewItem = state.allItems.filter(
        (item) => !(item.item.Id === action.payload?.item?.Id),
      );
      /*NEW STUFF*/

      return {
        ...state,
        data: [...dataWithoutNewItemSuccess, newItemSuccess],
        lastUpdatedItem: newItemSuccess,
        allItems: [
          ...allItemsWithoutNewItem,
          { item: newItemSuccess, data: { type: 'draft', types: ['draft'] } },
        ],
      };
    }

    case '[Catalog] Error Update Item':
      if (state.lastDeletedItem) {
        return {
          ...state,
          errorUpdateItem: action.error,
          data: [...state.data, state.lastUpdatedItem],
        };
      } else {
        return { ...state, errorUpdateItem: action.error };
      }

    case '[Catalog] Clear store':
      return initialState;
    default:
      return state;

    /**
     *  Inventory Items reducer
     */
    case '[Catalog] Loading Get Inventory Items':
      return { ...state, loadingInventoryItems: true };
    case '[Catalog] Loaded Get Inventory Items':
      return { ...state, loadingInventoryItems: false };
    case '[Catalog] Success Get Inventory Items': {
      //This adds the data to the allItems array, omitting the duplicates and leaving only the ones in newData.
      const initialData = state.allItems;
      const newData: CatalogItemExtended[] =
        action?.payload?.response.data?.Items.map((item: CatalogItem) => {
          return {
            item,
            data: {
              type: 'inventory',
              permissions: action.payload.inventoryItems.find(
                (inventoryItem) => inventoryItem.Id === item.Id,
              ).DisplayProperties['Permissions'],
            },
          };
        });

      const allItems = mergeCatalogItemsExtended(initialData, newData); /*.map(
        (item) => {
          return { ...item, item: { ...item.item, Contents: [] } };
        },
      );*/
      return {
        ...state,
        allItems: allItems,
        // inventoryItems: action?.payload?.data?.Items,
      };
    }
    case '[Catalog] Error Get Inventory Items':
      return { ...state };

    case '[Catalog] Loading Delete Inventory Items':
      return { ...state };
    case '[Catalog] Loaded Delete Inventory Items':
      return { ...state };
    case '[Catalog] Success Delete Inventory Items': {
      const inventoryItemsFiltered = state.inventoryItems?.filter(
        (item) => action.payload.Item.Id !== item.Id,
      );
      return { ...state, inventoryItems: inventoryItemsFiltered };
    }
    case '[Catalog] Error Delete Inventory Items':
      return { ...state };

    case '[Catalog] Loading Create Inventory Item':
      //Add data before the server answers

      return { ...state, loadingCreateInventoryItem: true };
    case '[Catalog] Loaded Create Inventory Item':
      return { ...state, loadingCreateInventoryItem: false };
    case '[Catalog] Success Create Inventory Item': {
      const purchasedItems: CatalogItem[] = action.payload;

      const inventoryWithoutNewItems = state.inventoryItems.filter(
        (inventoryItem) => {
          return !purchasedItems.some(
            (purchasedItem) => purchasedItem.Id === inventoryItem.Id,
          );
        },
      );

      /*NEW STUFF*/
      const allItemsInventoryWithoutNewItems = state.allItems.filter(
        (inventoryItem) => {
          return !purchasedItems.some(
            (purchasedItem) =>
              purchasedItem.Id === inventoryItem.item.Id &&
              inventoryItem.data.type === 'inventory',
          );
        },
      );

      const purchasedItemsExtended: CatalogItemExtended[] = purchasedItems.map(
        (item) => {
          return {
            item: item,
            data: {
              type: 'inventory',
            },
          };
        },
      );
      /*NEW STUFF*/

      //Add the items to the inventory again
      return {
        ...state,
        inventoryItems: [...inventoryWithoutNewItems, ...purchasedItems],
        allItems: [
          ...allItemsInventoryWithoutNewItems,
          ...purchasedItemsExtended,
        ],
      };
    }

    case '[Catalog] Error Create Inventory Item':
      //TODO: Handle error
      return { ...state, errorCreateInventoryItem: action.error };

    /**
     *  CRM reducer
     */
    case '[Catalog] Loading Get Crm Items':
      return { ...state, crm: { ...state.crm, loading: true } };
    case '[Catalog] Loaded Get Crm Items':
      return { ...state, crm: { ...state.crm, loading: false } };
    case '[Catalog] Success Get Crm Items':
      return {
        ...state,
        crm: { ...state.crm, data: action.payload, loading: true },
      };
    case '[Catalog] Error Get Crm Items':
      return {
        ...state,
        crm: { ...state.crm, loading: false, error: action.error },
      };

    /**
     *  CRM Pagination reducer
     */
    case '[Catalog] Loading Get Next Crm Items':
      return { ...state, crm: { ...state.crm } };
    case '[Catalog] Loaded Get Next Crm Items':
      return { ...state, crm: { ...state.crm, loading: false } };
    case '[Catalog] Success Get Next Crm Items': {
      const AwaitingModerationItems = [
        ...state.crm.data.Items.AwaitingModeration.Items,
        ...action.payload.Items.AwaitingModeration.Items,
      ];

      const AwaitingModeration = {
        Items: AwaitingModerationItems,
        Total: AwaitingModerationItems.length,
      };

      const RejectedItems = [
        ...state.crm.data.Items.Rejected.Items,
        ...action.payload.Items.Rejected.Items,
      ];
      const Rejected = { Items: RejectedItems, Total: RejectedItems.length };

      const ApprovedItems = [
        ...state.crm.data.Items.Approved.Items,
        ...action.payload.Items.Approved.Items,
      ];
      const Approved = { Items: ApprovedItems, Total: ApprovedItems.length };

      return {
        ...state,
        crm: {
          ...state.crm,
          data: {
            Items: {
              AwaitingModeration,
              Rejected,
              Approved,
            },
            ContinuationToken: action.payload.ContinuationToken,
          },
          loading: false,
        },
      };
    }
    case '[Catalog] Error Get Next Crm Items':
      return {
        ...state,
        crm: { ...state.crm, loading: false, error: action.error },
      };

    /**
     *  CRM Moderation reducer
     */
    case '[Catalog] Loading Set Moderation Crm Item': {
      //Put all items in one single array
      const allItems: CatalogItem[] = [];
      Object.entries(state.crm.data.Items).map((modStatus) => {
        const crmItems = modStatus[1].Items;
        allItems.push(...crmItems);
      });

      let itemToModify = undefined;

      //Get an array without the item we want to modify, and store that item as itemToModify
      const filteredData = allItems.filter((item) => {
        if (item.Id === action.payload.Id) {
          //Found the item we want to modify, store it
          itemToModify = item;
        }
        return item.Id !== action.payload.Id;
      });

      //Create a hard copy just in case
      const modifiedItem = JSON.parse(JSON.stringify(itemToModify));

      //Modify the item
      modifiedItem.Moderation.Status = action.payload.Status;
      modifiedItem.Moderation.Reason = action.payload?.Reason;
      modifiedItem.Moderation.LastModifiedDate =
        action.payload?.LastModifiedDate;

      //Add it back to the array
      const newItemsArray = [...filteredData, modifiedItem];

      //Organize the data to commit it to the state
      const getItemsByModerationStatus = (status, data) => {
        return data.filter((item) => item.Moderation.Status == status);
      };

      const awaitingModerationItems = getItemsByModerationStatus(
        'AwaitingModeration',
        newItemsArray,
      );

      const rejectedItems = getItemsByModerationStatus(
        'Rejected',
        newItemsArray,
      );

      const approvedItems = getItemsByModerationStatus(
        'Approved',
        newItemsArray,
      );

      //Final result
      const finalData = {
        AwaitingModeration: {
          Total: awaitingModerationItems.length,
          Items: awaitingModerationItems,
        },
        Rejected: {
          Total: rejectedItems.length,
          Items: rejectedItems,
        },
        Approved: {
          Total: approvedItems.length,
          Items: approvedItems,
        },
      };

      return {
        ...state,
        crm: {
          data: {
            ...state.crm.data,
            Items: { ...finalData },
          },
        },
      };
    }
    case '[Catalog] Loaded Set Moderation Crm Item':
      return { ...state };
    case '[Catalog] Success Set Moderation Crm Item':
      return { ...state };
    case '[Catalog] Error Set Moderation Crm Item':
      //Roll back changes in state

      return { ...state };

    /**
     *  Creator Store Universes reducer
     */
    case '[Catalog] Loading Get Creator Store Universe Items':
      return {
        ...state,
        creatorStoreUniverses: {
          ...state.creatorStoreUniverses,
          loading: true,
        },
      };
    case '[Catalog] Loaded Get Creator Store Universe Items':
      return {
        ...state,
        creatorStoreUniverses: {
          ...state.creatorStoreUniverses,
          loading: false,
        },
      };
    case '[Catalog] Success Get Creator Store Universe Items': {
      /*NEW STUFF*/
      //This adds the data to the allItems array, omitting the duplicates and leaving only the ones in newData.
      const itemsPayload = action.payload;
      const initialData = state.allItems;

      const newData: CatalogItemExtended[] = itemsPayload.map((item) => {
        const { ...rest } = item;
        return {
          item: rest,
          data: {
            type: 'creatorStoreUniverses',
          },
        };
      });

      const allItems = mergeCatalogItemsExtended(initialData, newData);
      return {
        ...state,
        allItems: allItems,
        creatorStoreUniverses: { data: itemsPayload, loading: false },
        loading: true,
      };
    }
    case '[Catalog] Error Get Creator Store Universe Items':
      return {
        ...state,
        creatorStoreUniverses: {
          ...state.creatorStoreUniverses,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Creator Store Adventures reducer
     */
    case '[Catalog] Loading Get Creator Store Adventure Items':
      return {
        ...state,
        creatorStoreAdventures: {
          ...state.creatorStoreAdventures,
          loading: true,
        },
      };
    case '[Catalog] Loaded Get Creator Store Adventure Items':
      return {
        ...state,
        creatorStoreAdventures: {
          ...state.creatorStoreAdventures,
          loading: false,
        },
      };
    case '[Catalog] Success Get Creator Store Adventure Items': {
      /*NEW STUFF*/
      //This adds the data to the allItems array, omitting the duplicates and leaving only the ones in newData.
      const itemsPayload = action.payload;
      const initialData = state.allItems;

      const newData: CatalogItemExtended[] = itemsPayload.map((item) => {
        const { ...rest } = item;
        return {
          item: rest,
          data: {
            type: 'creatorStoreAdventures',
          },
        };
      });

      const allItems = mergeCatalogItemsExtended(initialData, newData);
      return {
        ...state,
        allItems: allItems,
        creatorStoreAdventures: action?.payload?.data?.Items,
        loading: true,
      };
    }
    case '[Catalog] Error Get Creator Store Adventure Items':
      return {
        ...state,
        creatorStoreAdventures: {
          ...state.creatorStoreAdventures,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Player Store reducer
     */
    case '[Catalog] Loading Get Player Store Items':
      return { ...state, playerStore: { ...state.playerStore, loading: true } };
    case '[Catalog] Loaded Get Player Store Items':
      return {
        ...state,
        playerStore: { ...state.playerStore, loading: false },
      };
    case '[Catalog] Success Get Player Store Items':
      return {
        ...state,
        playerStore: {
          ...state.playerStore,
          data: action.payload,
          loading: true,
        },
      };
    case '[Catalog] Error Get Player Store Items':
      return {
        ...state,
        playerStore: {
          ...state.playerStore,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Inventory item reducer
     */
    case '[Catalog] Loading Update Inventory Item':
      return {
        ...state,
        inventoryItem: { ...state.inventoryItem, loading: true },
      };
    case '[Catalog] Loaded Update Inventory Item':
      return {
        ...state,
        inventoryItem: { ...state.inventoryItem, loading: false },
      };
    case '[Catalog] Success Update Inventory Item':
      return {
        ...state,
        inventoryItem: {
          ...state.inventoryItem,
          data: action.payload,
          loading: true,
        },
      };
    case '[Catalog] Error Update Inventory Item':
      return {
        ...state,
        inventoryItem: {
          ...state.inventoryItem,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Inventory item reducer
     */
    case '[Catalog] Loading Update Inventory Items':
      return {
        ...state,
        inventoryItems: [...state.inventoryItems],
      };
    case '[Catalog] Loaded Update Inventory Items':
      return {
        ...state,
        inventoryItem: { ...state.inventoryItem, loading: false },
      };
    case '[Catalog] Success Update Inventory Items':
      return {
        ...state,
        inventoryItem: {
          ...state.inventoryItem,
          data: action.payload,
          loading: true,
        },
      };
    case '[Catalog] Error Update Inventory Items':
      return {
        ...state,
        inventoryItem: {
          ...state.inventoryItem,
          loading: false,
          error: action.error,
        },
      };

    case 'add-inventory-items': {
      const newInventoryItemsExtended: CatalogItemExtended[] =
        action.payload.items.map(
          (purchaseOrder: {
            item: CatalogItem;
            price: number;
            permissions: ('Play' | 'Duplicate' | 'Create')[];
          }) => {
            return {
              item: purchaseOrder.item,
              data: {
                type: 'inventory',
                types: ['inventory'],
                permissions: purchaseOrder.permissions,
              },
            };
          },
        );


      // Function to merge permissions without duplicates
      const mergePermissions = (
        existingPermissions: ('Play' | 'Duplicate' | 'Create')[],
        newPermissions: ('Play' | 'Duplicate' | 'Create')[],
      ) => {
        const permissionSet = new Set(existingPermissions);
        newPermissions.forEach((permission) => permissionSet.add(permission));
        return Array.from(permissionSet);
      };

      const updatedAllItems = state.allItems.map((existingItem) => {
        const newItem = newInventoryItemsExtended.find(
          (newItem) => newItem.item.Id === existingItem.item.Id,
        );

        if (newItem) {
          return {
            ...existingItem,
            data: {
              ...existingItem.data,
              permissions: mergePermissions(
                existingItem.data.permissions as (
                  | 'Play'
                  | 'Duplicate'
                  | 'Create'
                )[],
                newItem.data.permissions as ('Play' | 'Duplicate' | 'Create')[],
              ),
            },
          };
        } else {
          return existingItem;
        }
      });

      // Add any new items that were not in the original array
      const addedItems = newInventoryItemsExtended.filter(
        (newItem) =>
          !state.allItems.some(
            (existingItem) => existingItem.item.Id === newItem.item.Id,
          ),
      );

      return {
        ...state,
        allItems: [...updatedAllItems, ...addedItems],
      };
    }

    /**
     *  Archived Inventory items reducer
     */
    case '[Catalog] Loading Get Recycled Inventory Items':
      return {
        ...state,
        recycledInventoryItems: {
          ...state.recycledInventoryItems,
          loading: true,
        },
      };
    case '[Catalog] Loaded Get Recycled Inventory Items':
      return {
        ...state,
        recycledInventoryItems: {
          ...state.recycledInventoryItems,
          loading: false,
        },
      };
    case '[Catalog] Success Get Recycled Inventory Items':
      return {
        ...state,
        recycledInventoryItems: {
          ...state.recycledInventoryItems,
          data: action.payload,
          loading: true,
        },
      };
    case '[Catalog] Error Get Recycled Inventory Items':
      return {
        ...state,
        recycledInventoryItems: {
          ...state.recycledInventoryItems,
          loading: false,
          error: action.error,
        },
      };

    /**
     *  Get contributor items reducer
     */
    case '[Catalog] Loading Get Contributor Items':
      return {
        ...state,
        contributors: { ...state.contributors, loading: true },
      };
    case '[Catalog] Loaded Get Contributor Items':
      return {
        ...state,
        contributors: { ...state.contributors, loading: false },
      };
    case '[Catalog] Success Get Contributor Items': {
      const itemsPayload: CatalogItem[] = action.payload;
      const initialData = state.allItems || [];
      const newData: CatalogItemExtended[] = itemsPayload.map(
        (item: CatalogItem) => {
          const primaryType: ItemType = 'contributor';
          return {
            item: item,
            data: { type: primaryType, types: [primaryType] },
          };
        },
      );
      const allItems = mergeCatalogItemsExtended(initialData, newData);

      return {
        ...state,
        allItems: allItems,
        contributors: {
          data: itemsPayload,
          loading: false,
          error: null,
        },
      };
    }

    case '[Catalog] Error Get Contributor Items':
      console.error('[Reducer] Action: [Catalog] Error Get Contributor Items - Error:', action.error);
      return {
        ...state,
        contributors: {
          ...(state.contributors || { data: [] }),
          loading: false,
          error: action.error,
        },
      };

    case '[Catalog API] Get Public Item Success': {
      const newItem: CatalogItem = action.payload.item;

      const newItemExtended: CatalogItemExtended = {
        item: newItem,
        data: {
          type: 'inventory',
          types: ['inventory']
        }
      };
      const allItems = mergeCatalogItemsExtended(state.allItems, [newItemExtended]);

      return {
        ...state,
        allItems: allItems,
      };
    }
  }
}

/**
 * Merges two arrays of CatalogItemExtended objects.
 * - It uses a Map to ensure item uniqueness based on `item.Id`.
 * - When an item from `newlyFetchedItemsExtended` already exists in `currentAllItems`,
 * it merges their `data.types` arrays, ensuring all unique types are present.
 * - The primary `data.type` is determined giving priority to 'draft'. If the existing item
 * is not 'draft' and had no primary type, the new item's primary type is used.
 * Otherwise, the existing primary type is generally maintained.
 * - If an item from `newlyFetchedItemsExtended` has a more recent `LastModifiedDate`,
 * its `item` properties will update the existing item's properties.
 *
 * @param currentAllItems - The array of CatalogItemExtended currently in the store/state.
 * @param newlyFetchedItemsExtended - The array of new CatalogItemExtended to merge in.
 * @returns A new array of CatalogItemExtended with items merged and duplicates handled.
 */
function mergeCatalogItemsExtended(
  currentAllItems: CatalogItemExtended[] = [],
  newlyFetchedItemsExtended: CatalogItemExtended[] = []
): CatalogItemExtended[] {
  const itemMap = new Map<string, CatalogItemExtended>();
  for (const existingItemExt of currentAllItems) {
    if (existingItemExt?.item?.Id) {
      let typesArray: ItemType[] = [];
      if (Array.isArray(existingItemExt.data.types)) {
        typesArray = [...new Set(existingItemExt.data.types.filter(t => t != null) as ItemType[])];
      } else if (existingItemExt.data.type) {
        typesArray = [existingItemExt.data.type];
      }

      itemMap.set(existingItemExt.item.Id, {
        ...existingItemExt,
        data: {
          ...existingItemExt.data,
          types: typesArray,
        },
      });
    }
  }

  for (const newItemExt of newlyFetchedItemsExtended) {
    if (newItemExt?.item?.Id) {
      const itemId = newItemExt.item.Id;
      const newPrimaryTypeFromNewItem: ItemType | undefined = newItemExt.data.type;
      const newTypesSourceArray = new Set<ItemType>();
      if (newPrimaryTypeFromNewItem) {
        newTypesSourceArray.add(newPrimaryTypeFromNewItem);
      }
      if (Array.isArray(newItemExt.data.types)) {
        newItemExt.data.types.forEach(t => {
          if (t) newTypesSourceArray.add(t as ItemType);
        });
      }
      if (itemMap.has(itemId)) {
        const existingItemExt = itemMap.get(itemId)!;
        const combinedTypes = new Set<ItemType>(existingItemExt.data.types || []);
        newTypesSourceArray.forEach(t => combinedTypes.add(t));
        existingItemExt.data.types = Array.from(combinedTypes);

        if (newPrimaryTypeFromNewItem === 'draft') {
          existingItemExt.data.type = 'draft';
        } else if (!existingItemExt.data.type && newPrimaryTypeFromNewItem) {
          existingItemExt.data.type = newPrimaryTypeFromNewItem;
        }
        if (new Date(newItemExt.item.LastModifiedDate) > new Date(existingItemExt.item.LastModifiedDate)) {
          existingItemExt.item = { ...existingItemExt.item, ...newItemExt.item };
        }
        itemMap.set(itemId, existingItemExt);

      } else {
        const typesForNewEntry = Array.from(newTypesSourceArray);
        itemMap.set(itemId, {
          ...newItemExt,
          data: { ...newItemExt.data, type: newPrimaryTypeFromNewItem, types: typesForNewEntry },
        });
      }
    }
  }
  const finalArray = Array.from(itemMap.values());
  return finalArray;
}
